export default __webpack_public_path__ + "_/shared_modules/common-images/clock-d135f8617d58d6ed5381d83101be445a.svg";